(ns web3.components.snackbar
  (:require [re-frame-simple.db :as db]
            [web3.view :as v]
            [web3.utils :as utils]
            [reagent.core :as r]
            [web3.constants :as constants]))

(def display-time 3000)
(def transition-time 200)
(def timeouts (atom {}))

(declare pop-snack!)

(defn- clear-timers
  "Stop in-progress timers."
  []
  (doseq [[_ timeout] (seq @timeouts)]
    (js/clearTimeout timeout)))

(defn- start-cycle
  "Show snack for `remaining-time`, then hide, removing from stack after transition is complete."
  ([this] (start-cycle this display-time))
  ([{:keys [state] :as this} remaining-time]
   (swap! state assoc :visible? true)
   (clear-timers)                                           ;; just to be sure
   (swap! timeouts assoc :hide (utils/wait remaining-time
                                           (swap! state dissoc :visible?)))
   (swap! timeouts assoc :pop (utils/wait (+ remaining-time transition-time)
                                          (pop-snack! this)))))

(defn- pop-snack!
  "Remove oldest snack from stack.

  If another snack remains, start the visibility-cycle over again."
  [this]
  (let [more-snacks (> (count (db/get ::snacks)) 1)]
    (db/dispatch [:update ::snacks drop-last])
    (if more-snacks
      (start-cycle this)
      (swap! (:state this) dissoc :visible?))))

(defn add-snack! [content]
  (db/dispatch [:update ::snacks conj content]))

(v/defview snackbar
  "Snackbar component, similar to https://material-components-web.appspot.com/snackbar.html

  Call `add-snack!` with the content to be displayed. Snackbar will animate up from bottom of
  the screen, show itself for 3000 miilliseconds (see `display-time`), then animate out.

  Multiple snacks will be displayed sequentially.

  To better facilitate user actions, snackbar will freeze in place on hover. When the mouse
  leaves the snackbar, it will hide itself after 500ms."
  {:component-will-receive-props
   (fn [{prev-props :props
         :as this} [_ next-props]]
     (when (and (seq (:snacks next-props))
                (not (seq (:snacks prev-props))))
       (start-cycle this)))
   :component-did-mount
   (fn [this]
     (when (seq (:snacks (:props this)))
       (start-cycle this)))}
  [{:keys [snacks]}]
  (let [{:keys [state] :as this} (r/current-component)
        {:keys [visible?]} @state]
    [:div.fixed.bottom-0.flex.justify-center
     {:style {:transition "0.2s ease bottom"
              :bottom (if visible? 0 -60)
              :width 0
              :left "50%"
              :z-index (:snackbar constants/z-index)}}
     (when-let [snack (last snacks)]
       [:div.bg-black.inline-flex.items-center.pad-h-3.text-white.nowrap
        {:style {:height 60}
         :on-mouse-enter clear-timers
         :on-mouse-leave #(start-cycle this 500)}
        snack])]))

(comment
 (add-snack! (str "Message " (rand-nth "ABCDEFGHIJKLMNOPQR"))))